
import { supabase } from '../../client';
import { Customer, Shop } from '../types';

/**
 * Add shop information to customers
 */
export const addShopInfoToCustomers = async (customers: Customer[]): Promise<Customer[]> => {
  if (!customers || customers.length === 0) {
    return [];
  }

  console.log(`[addShopInfoToCustomers] Adding shop info to ${customers.length} customers`);
  
  try {
    // Get all unique shop IDs from customers
    const shopIds = Array.from(new Set(
      customers
        .filter(customer => customer.shop_id)
        .map(customer => customer.shop_id)
    )).filter(Boolean) as string[];
    
    if (shopIds.length === 0) {
      console.log('[addShopInfoToCustomers] No shop IDs found in customers');
      return customers;
    }
    
    console.log(`[addShopInfoToCustomers] Fetching info for ${shopIds.length} shops`);
    
    // Get shop data for these shop IDs
    const { data: shops, error } = await supabase
      .from('shops')
      .select('*')
      .in('id', shopIds);
      
    if (error) {
      console.error('[addShopInfoToCustomers] Error fetching shops:', error);
      return customers;
    }
    
    if (!shops || shops.length === 0) {
      console.log('[addShopInfoToCustomers] No shops found');
      return customers;
    }
    
    console.log(`[addShopInfoToCustomers] Found ${shops.length} shops`);
    
    // Create a map of shop ID to shop for fast lookups
    const shopsMap: Record<string, Shop> = {};
    
    shops.forEach(shop => {
      shopsMap[shop.id] = {
        id: shop.id,
        name: shop.name,
        logo_url: shop.logo_url,
        category: shop.category
      };
    });
    
    // Add shop data to each customer
    const customersWithShops = customers.map(customer => {
      const shop = customer.shop_id ? shopsMap[customer.shop_id] : undefined;
      
      return {
        ...customer,
        shops: shop ? [shop] : undefined
      };
    });
    
    return customersWithShops;
  } catch (error) {
    console.error('[addShopInfoToCustomers] Exception:', error);
    return customers;
  }
};
